import React from 'react';

import config from '../../config';
import {RouteData} from '../types';
import {
  PROFILE_BASE_PATH,
  PROFILE_BASE_PROJECTS_PATH,
  PROFILE_BASE_REPORTS_PATH,
  PROFILE_BASE_SETTINGS_PATH,
  PROFILE_BASE_STARS_PATH,
  PROFILE_PROJECTS_PATH,
  PROFILE_REPORTS_PATH,
  PROFILE_STARS_PATH,
  TEAM_MEMBERS_PATH,
  TEAM_SERVICE_ACCOUNTS_PATH,
  TEAM_SETTINGS_PATH,
} from './teamPaths';

export const CREATE_TEAM_ROUTE_DATA: RouteData = {
  additionalProps: {
    allowIframes: false,
    routeName: 'CreateNewTeam',
  },
  condition: !config.ENVIRONMENT_IS_PRIVATE,
  exact: true,
  isPrivateRoute: true,
  path: '/create-team',
  RouteComponent: React.lazy(() => import('../../pages/CreateNewTeamPage')),
};

// New profile-specific routes (canonical URLs for personal entities)
export const PROFILE_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {allowIframes: false, routeName: 'Profile'},
    exact: true,
    isPrivateRoute: false,
    path: PROFILE_BASE_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/ProfilePage/ProfilePageRouter')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Profile',
      tab: 'reports',
    },
    exact: true,
    isPrivateRoute: false,
    path: PROFILE_BASE_REPORTS_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/ProfilePage/ProfilePageRouter')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Profile',
      tab: 'projects',
    },
    exact: true,
    isPrivateRoute: false,
    path: PROFILE_BASE_PROJECTS_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/ProfilePage/ProfilePageRouter')
    ),
  },
  {
    additionalProps: {allowIframes: false, routeName: 'Profile', tab: 'stars'},
    exact: true,
    isPrivateRoute: false,
    path: PROFILE_BASE_STARS_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/ProfilePage/ProfilePageRouter')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Profile',
      tab: 'settings',
    },
    exact: true,
    isPrivateRoute: false,
    path: PROFILE_BASE_SETTINGS_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/ProfilePage/ProfilePageRouter')
    ),
  },
];

export const TEAM_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {allowIframes: false, routeName: 'Entity', tab: 'reports'},
    exact: true,
    isPrivateRoute: false,
    path: PROFILE_REPORTS_PATH,
    RouteComponent: React.lazy(() => import('../../pages/EntityPage')),
    // note that here and below, we rely on the fact that we include the tab
    // when we log the route name
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Entity',
      tab: 'projects',
    },
    exact: true,
    isPrivateRoute: false,
    path: PROFILE_PROJECTS_PATH,
    RouteComponent: React.lazy(() => import('../../pages/EntityPage')),
  },
  {
    additionalProps: {allowIframes: false, routeName: 'Entity', tab: 'stars'},
    exact: true,
    isPrivateRoute: false,
    path: PROFILE_STARS_PATH,
    RouteComponent: React.lazy(() => import('../../pages/EntityPage')),
  },
  {
    additionalProps: {allowIframes: false, routeName: 'Entity', tab: 'members'},
    exact: true,
    isPrivateRoute: false,
    path: TEAM_MEMBERS_PATH,
    RouteComponent: React.lazy(() => import('../../pages/EntityPage')),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Entity',
      tab: 'service-accounts',
    },
    exact: true,
    isPrivateRoute: false,
    path: TEAM_SERVICE_ACCOUNTS_PATH,
    RouteComponent: React.lazy(() => import('../../pages/EntityPage')),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Entity',
      tab: 'settings',
    },
    exact: true,
    isPrivateRoute: false,
    path: TEAM_SETTINGS_PATH,
    RouteComponent: React.lazy(() => import('../../pages/EntityPage')),
  },
  // TODO: Remove! Keeping for backwards compatibility (email links, etc)
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Entity',
      tab: 'settings',
    },
    exact: true,
    isPrivateRoute: false,
    path: '/teams/:entityName',
    RouteComponent: React.lazy(() => import('../../pages/EntityPage')),
  },
];
